<script lang="ts">
  import Button, { type ButtonProps } from "@elements/Button.svelte";
  import clsx from "clsx";

  export let title = "";
  export let moreButton: ButtonProps | null = null;
</script>

<div class={clsx("container", $$props.class)}>
  <hr class="border-s500 my-6" />
  <div class="flex justify-between items-center pb-6">
    <h2 class="text-white text-h2 font-light">{title}</h2>
    {#if moreButton}
      <Button
        {...{
          ...{
            variant: "cta",
            color: "white",
            class: "hidden invisible md:block md:visible",
          },
          ...moreButton,
        }}
      />
    {/if}
  </div>
</div>
<slot />
